module.exports = __webpack_public_path__ + "img/fazhan.399f2871.png";